export const findShippingOption = (options, code) => {
  if (!options) return undefined

  return options.find(option => option.code === code)
}

export enum ModalKeys {
  ReturnShippingOptionsModal = 'return_shipping_options_modal',
  ShippingDiscountModal = 'shipping_discount_modal',
  ReturnCurrencyConversionModal = 'return_currency_conversion_modal',
  EstimatedRefundInformation = 'estimated_refund_information',
  GenericErrorModal = 'generic_error_modal',
}
